export default __webpack_public_path__ + "static/media/fork.d996771c.svg";